<deprecated-search-field
  [placeholder]="placeholder"
  [disabled]="disabled"
  [queryParamName]="queryParamName"
  [ngModel]="filter"
  (ngModelChange)="filterChanged($event)"
  (input)="filterChanged($event.target.value)"
  [focusOnInit]="autoFocus"
  [tabindex]="0"
  (blur)="blur.emit($event)"
  (focus)="focus.emit($event)"
  (keydown)="filterKeydown($event)"
  [class.showBottomBorder]="!hideOptions"
  [purp]="true"
  *ngIf="type == 'search'"
></deprecated-search-field>
<input
  #inputElement
  [placeholder]="placeholder"
  [disabled]="disabled"
  [value]="filter"
  (input)="filterChanged($event.target.value)"
  [focusOnInit]="autoFocus"
  [tabindex]="0"
  (blur)="blur.emit($event)"
  (focus)="focus.emit($event)"
  (keydown)="filterKeydown($event)"
  [class.showBottomBorder]="!hideOptions"
  *ngIf="type != 'search'"
  [type]="type"
/>
<div
  class="option-content rv-grow rv-scrollable"
  [class.disabled]="disabled"
  *ngIf="!hideOptions"
>
  <ng-content *ngIf="!filterEmpty"></ng-content>
  <div *ngIf="filterEmpty" class="filter-empty">
    No options matching "{{ filter }}"
  </div>
</div>
